import React from 'react';
import { CellWrapper } from '../../styles';

export const IdCell = (value: any) => (
  <CellWrapper>
    {value.value}
  </CellWrapper>
);
